import { render, staticRenderFns } from "./MenuTeamReportAndSummaryList.vue?vue&type=template&id=06bc9ce8&scoped=true"
var script = {}
import style0 from "./MenuTeamReportAndSummaryList.vue?vue&type=style&index=0&id=06bc9ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc9ce8",
  null
  
)

export default component.exports